import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bs-select-options" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["bs-select-options__option", {
                'option--selected': _ctx.isOptionSelected(option)
            }]),
        key: `option-${i}`,
        onClick: ($event: any) => (_ctx.onSelectOption(option))
      }, _toDisplayString(option[_ctx.displayBy]), 11, _hoisted_2))
    }), 128))
  ]))
}